import React from 'react';

const IconSpanish = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    {/* Azul superior */}
    <path fill="#002B7F" d="M0 0h640v96H0z" />
    {/* Franja blanca superior */}
    <path fill="#FFFFFF" d="M0 96h640v48H0z" />
    {/* Franja roja central */}
    <path fill="#CE1126" d="M0 144h640v192H0z" />
    {/* Franja blanca inferior */}
    <path fill="#FFFFFF" d="M0 336h640v48H0z" />
    {/* Azul inferior */}
    <path fill="#002B7F" d="M0 384h640v96H0z" />
  </svg>
);

export default IconSpanish;
